export const experienceData = [
    {
        id: 1,
        company: 'enshift AG',
        jobtitle: 'Quality Assurance Engineer',
        startYear: '2025',
        endYear: 'to present'
    },
    {
        id: 2,
        company: 'Adymco / Grupo Fanteiane',
        jobtitle: 'Project Manager / Administrative and Financial Operations Manager',
        startYear: '2014',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Divertiperro',
        jobtitle: 'Receptionist and Accounting',
        startYear: '2012',
        endYear: '2014'
    }
    
]